<template>
  <div class="columns my-0 is-multiline">
    <div class="column is-narrow">
      <kst-input floating-label
        field="WarehouseID" :data="searchData" :catalog="DaiSearchCatalog"
        :options="warehouseOptions" @input="handleInput"
      />
    </div>
    <div class="column is-narrow">
      <kst-input floating-label
        field="Date" :data="searchData" :catalog="DaiSearchCatalog"
        @input="handleInput"
      />
    </div>
    <div class="column is-narrow">
      <kst-input floating-label
        field="SearchResultID" :data="searchData" :catalog="DaiSearchCatalog"
        :options="searchResultOptions" @input="handleInput"
      />
    </div>
  </div>
</template>

<script>
import Model from "../DaiModel.js";
import DaiSearchCatalog from "../DaiSearchCatalog.js";

export default {
  props: {
    searchData: Object,
    warehouseOptions: Object
  },
  computed:{
    searchResultOptions(){
      return Model.createSearchResultOptions(
        DaiSearchCatalog.SearchResultID.Label
      );
    }
  },
  data: () => ({
    DaiSearchCatalog: DaiSearchCatalog
  }),
  methods: {
    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    }
  }
}
</script>